import { Routes } from "@angular/router";
import { PermissionsDetailsComponent } from "./permissions-details/permissions-details.component";
import { PermissionsDeleteComponent } from "./permissions-delete/permissions-delete.component";
import { PermissionsEditComponent } from "./permissions-edit/permissions-edit.component";
import { PermissionsCreateComponent } from "./permissions-create/permissions-create.component";
import { PermissionsListComponent } from "./permissions-list/permissions-list.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const permissionsRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: PermissionsListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: PermissionsCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: PermissionsEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: PermissionsDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: PermissionsDetailsComponent, canActivate: [actionsGuard] },
]
